import { getWalletIcon } from '../icons.js';
export const getConnectorIcon = (connector) => {
    const connectorId = connector?.id;
    return connectorId
        ? getWalletIcon(connectorId) || connector?.icon
        : connector?.icon;
};
//# sourceMappingURL=getConnectorIcon.js.map